import { Component, OnInit } from '@angular/core';
import { QrCodeModule } from 'ng-qrcode';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { WalletDialogType, WalletService } from './../wallet.service';

@Component({
  selector: 'address-qr',
  standalone: true,
  imports: [CSIconButtonComponent, CSButtonComponent, QrCodeModule],
  templateUrl: './address-qr.component.html',
  styleUrl: './address-qr.component.scss',
})
export class AddressQrComponent implements OnInit {
  constructor(public walletService: WalletService) {}
  ngOnInit(): void {}
  goBack() {
    this.walletService.setWalletDialogType(WalletDialogType.DEPOSIT_WITHDRAW);
  }
}
